import { FeedbackItem } from "../types/Model";
import {
  ACTION_TYPES,
  createData,
  getDataNoParams,
  getDataWithParams,
  postData,
  updateData,
} from "./modelUtils";

/**
 * Lists all user feedback from DynamoDB
 */
export async function listUserFeedback(): Promise<FeedbackItem[]> {
  return await getDataNoParams({
    action: ACTION_TYPES.LIST_USER_FEEDBACK,
    labelLogName: "user feedback",
    dataField: "feedback",
  });
}

/**
 * Get user feedback by id
 */
export async function getUserFeedback(
  feedbackId: string
): Promise<FeedbackItem> {
  return await getDataWithParams({
    action: ACTION_TYPES.GET_USER_FEEDBACK,
    labelLogName: "user feedback",
    dataField: "feedback",
    params: {
      id: feedbackId,
      idFieldName: "feedbackId",
    },
  });
}

export async function saveUserFeedbackAssigned(
  feedbackId: string,
  assigned: string
): Promise<void> {
  const fields = {
    assigned: assigned,
  };
  return await updateData({
    action: ACTION_TYPES.SAVE_USER_FEEDBACK_ASSIGNED,
    labelLogName: "user feedback assigned",
    idFieldName: "feedbackId",
    id: feedbackId,
    fields: fields,
    labelActionNameOverride: "save",
  });
}

/**
 * Updates user feedback by id
 */
export async function saveUserFeedback(
  feedbackId: string,
  comment: string,
  sendEmail: boolean
): Promise<void> {
  const fields = {
    comment: comment,
    sendEmail: sendEmail,
  };
  return await updateData({
    action: ACTION_TYPES.SAVE_USER_FEEDBACK,
    labelLogName: "user feedback",
    idFieldName: "feedbackId",
    id: feedbackId,
    fields: fields,
    labelActionNameOverride: "save",
  });
}

/**
 * Closes user feedback by id
 */
export async function closeUserFeedback(
  feedbackId: string,
  comment: string,
  sendEmail: boolean
): Promise<void> {
  const fields = {
    comment: comment,
    sendEmail: sendEmail,
  };
  return await updateData({
    action: ACTION_TYPES.CLOSE_USER_FEEDBACK,
    labelLogName: "user feedback",
    idFieldName: "feedbackId",
    id: feedbackId,
    fields: fields,
    labelActionNameOverride: "close",
  });
}

/**
 * Reopens user feedback by id
 */
export async function openUserFeedback(
  feedbackId: string,
  comment: string,
  sendEmail: boolean
): Promise<void> {
  const fields = {
    comment: comment,
    sendEmail: sendEmail,
  };
  return await updateData({
    action: ACTION_TYPES.OPEN_USER_FEEDBACK,
    labelLogName: "user feedback",
    idFieldName: "feedbackId",
    id: feedbackId,
    fields: fields,
    labelActionNameOverride: "open",
  });
}

/**
 * Downloads user feedback as CSV
 */
export async function downloadUserFeedback(): Promise<string> {
  return await postData({
    action: ACTION_TYPES.DOWNLOAD_USER_FEEDBACK,
    labelLogName: "user feedback",
    labelActionName: "to download",
    dataField: "feedback",
    fields: {},
  });
}

/**
 * Insert user feedback
 */
export async function insertUserFeedback({
  type,
  message,
  satisfied,
}: {
  type: string;
  message: string;
  satisfied: boolean;
}): Promise<void> {
  const fields = {
    type: type,
    satisfied: satisfied,
    message: message,
  };
  return await createData({
    action: ACTION_TYPES.INSERT_USER_FEEDBACK,
    labelLogName: "user feedback",
    fields: fields,
  });
}
